import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ClerkProvider, useAuth } from '@clerk/clerk-react'
import { ConvexProviderWithClerk } from 'convex/react-clerk'
import { ConvexReactClient } from 'convex/react'
import { ThirdwebProvider } from 'thirdweb/react'
import { AuthProvider } from './context/AuthContext'
import { WalletProvider } from './context/WalletContext'
import ErrorBoundary from './components/ErrorBoundary'
import App from './App'
import './index.css'
import './i18n' // Initialize i18n

// Production fallback for environment variables
const CONVEX_URL = import.meta.env.VITE_CONVEX_URL || 'https://incredible-iguana-973.convex.cloud'
const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || 'pk_test_aW1tZW5zZS1jaGltcC05Mi5jbGVyay5hY2NvdW50cy5kZXYk'

console.log('[FreakMe] Initializing app...')
console.log('[FreakMe] Convex URL:', CONVEX_URL)
console.log('[FreakMe] Clerk Key:', clerkPubKey ? 'present' : 'missing')

let convex: ConvexReactClient
try {
  convex = new ConvexReactClient(CONVEX_URL)
  console.log('[FreakMe] Convex client created')
} catch (e) {
  console.error('[FreakMe] Failed to create Convex client:', e)
  throw e
}

try {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ErrorBoundary>
        <ClerkProvider publishableKey={clerkPubKey}>
          <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
            {/* ThirdwebProvider for in-app wallets + social login */}
            <ThirdwebProvider>
              {/* WalletProvider (wagmi/RainbowKit) for contract interactions */}
              <WalletProvider>
                <BrowserRouter>
                  <AuthProvider>
                    <App />
                  </AuthProvider>
                </BrowserRouter>
              </WalletProvider>
            </ThirdwebProvider>
          </ConvexProviderWithClerk>
        </ClerkProvider>
      </ErrorBoundary>
    </StrictMode>,
  )
  console.log('[FreakMe] App rendered')
} catch (e) {
  console.error('[FreakMe] Failed to render app:', e)
  document.getElementById('root')!.innerHTML = `
    <div style="padding:2rem;text-align:center;color:#ff3366;background:#0f0f1a;min-height:100vh;display:flex;align-items:center;justify-content:center;flex-direction:column;">
      <h1>Error Loading App</h1>
      <p style="color:#888;">${e instanceof Error ? e.message : 'Unknown error'}</p>
      <button onclick="location.reload()" style="margin-top:1rem;padding:0.5rem 1rem;background:#ff3366;color:white;border:none;border-radius:4px;cursor:pointer;">Retry</button>
    </div>
  `
}
